import React, { FC, useCallback, useEffect, useState } from 'react'
import { format, parseISO, startOfMonth, endOfMonth } from 'date-fns'
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
  Button,
  Box,
  Checkbox,
  Flex,
  Text
} from '@chakra-ui/react'
import { IPropertiesProps } from '../../../interfaces/IPropertiesProps'
import { IHouseProps, IItemProps, IPriceHouseProps } from '../../../Hooks/Concierge'
import { SelectWithSearch } from '../../Form/SelectWithSearch'
import api from '../../../Services/api'
import { IUserProps } from '../../../interfaces/IUserProps'
import IOptionsProps from '../../../interfaces/IOptionsProps'
import { useForm } from 'react-hook-form'
import { DatePicker } from '../../Form/Datepicker'

interface IFilterUsersModalProps {
  open: boolean
  setOpen: (state: boolean) => void
  houses: IPropertiesProps[]
  onSubmit: (data?: any) => Promise<void>
  onClose: () => void
  houseFiltered: string[]
  
}

const FilterUsersModal: FC<IFilterUsersModalProps> = ({ 
  open, 
  setOpen, 
  houses, 
  onSubmit, 
  onClose, 
  houseFiltered,
}) => {
  const [tempItem, setTempItem] = useState<string[]>([])
  
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState<IOptionsProps[]>([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [error, setError] = useState(false)

  
  const { register } = useForm()

  const onClick = useCallback(async () => {
    
    await onSubmit({ houses: tempItem })
    onClose()
   
  }, [onSubmit, onClose, tempItem])

  const handleSelectHouse = useCallback(
    (house: string) => {

      if(house === 'club') {
        setTempItem(['club'])
        return
      }

      if(house === 'homes') {
        setTempItem(['homes'])
        return
      }
      
      const filteredTempItem = tempItem.filter(i => i !== 'club' && i !== 'homes')

      const exists = filteredTempItem.find(i => i === house)

      if (exists != null) {
        setTempItem(filteredTempItem.filter(i => i !== house))
        return
      }

      setTempItem([...filteredTempItem, house])
    },
    [tempItem]
  )

  useEffect(() => {
    setTempItem(houseFiltered)
    
  }, [houseFiltered])

  const handleRemoveAll = useCallback(() => {
    setTempItem([])
  }, [])

  const handleAddAll = useCallback(() => {
    const allHouseIds = houses.map(house => house.id)
    setTempItem(allHouseIds)
  }, [houses])



  const loadUsers = useCallback(async () => {
    setLoading(true)
    try {
      
      const { data } = await api.get('/users', {
        params: {
          pag: 1,
          all: true,
          active: [0, 1]
        }
      })

      const normalize = data?.data?.map((i: any) => {
        return {
          value: i.id,
          label: i.name
        }
      })

      setUsers(normalize)
    } catch (error) {
      console.log('erro ao pegar users: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadUsers()
  }, [])

  return (
    <Drawer isOpen={open} placement="right" onClose={() => setOpen(false)} size='md'>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Usuários - Filtros</DrawerHeader>
        <DrawerBody>

          <Text fontSize='16px' fontWeight='600' color='green.dark'>
            Visualizar usuários de quais casas?
          </Text>


          <Flex mt='20px'>
            <Button variant="outline" mr={3} onClick={handleRemoveAll}>
              Remover Todos
            </Button>
            <Button variant="outline" mr={3} onClick={handleAddAll}>
              Selecionar Todos
            </Button>
          </Flex>

          <Box mt='20px'>
          <Checkbox
               
                color="green.dark"
                value='club'
                isChecked={tempItem?.includes('club')}
                name={`availability-house-club`}
                style={{ padding: 5, color: '#000' }}
                onChange={(e) => handleSelectHouse('club')}
            >
                Visualizar apenas as Casas do Club
            </Checkbox>

            <Checkbox
               
                color="green.dark"
                value='club'
                isChecked={tempItem?.includes('homes')}
                name={`availability-house-homes`}
                style={{ padding: 5, color: '#000' }}
                onChange={(e) => handleSelectHouse('homes')}
            >
                Visualizar apenas as Casas do Homes
            </Checkbox>
          {houses.map((house) => (
            <Box w='100%' key={house.id}>
            <Checkbox
                key={house.id}
                color="green.dark"
                value={house.id}
                isChecked={tempItem?.includes(house.id)}
                name={`availability-house-${house.id}`}
                style={{ padding: 5, color: '#000' }}
                onChange={(e) =>
                  handleSelectHouse(house.id)
                }
            >
                {house.name}
            </Checkbox>
            </Box>
          ))}
          </Box>

         
        </DrawerBody>
        <DrawerFooter>
          <Button variant="outline" mr={3} onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button backgroundColor='green.dark' color='white' onClick={onClick}>Aplicar Filtros</Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}

export { FilterUsersModal }
